(function () {
  'use strict';

  angular.module('wsLrs.services').factory('OrganizationContext', ['$location', '$window', '$http', '$q', 'Config', '$cookies', 'Utils', 'Logger', 'Api', 'OrganizationSettings', function ($location, $window, $http, $q, Config, $cookies, Utils, Logger, Api, OrganizationSettings) {
    return {
      value: null,
      // Protect against cookies shared between *.domain.com
      // and domain.com (root) in IE by using host in cookie name
      cookieName: "organization-context-" + $location.host(),
      deferredOrg: null,
      load: function load() {
        var urlName = Utils.getQueryVariable("org"),
          self = this;

        // If we're already fetching it, return the promise of that fetch
        if (self.deferredOrg !== null) {
          return self.deferredOrg.promise;
        }

        // Otherwise, let's go fetch / resolve it
        self.deferredOrg = $q.defer();

        // If there's no urlName, we can't go get anything
        if (typeof urlName === "undefined" || urlName === null) {
          $cookies.remove(self.cookieName);
          self.value = null;
          self.deferredOrg.resolve(null);

          // Ok, let's try to go look up the org context now
        } else {
          var orgUrl = Api.url("/organizations/" + urlName, true),
            promise = $http.get(orgUrl);

          // Try to find organization by urlName first
          promise.then(function (response) {
            var org = response.data;
            if (org) {
              // Now go fetch their public org settings
              OrganizationSettings.getForOrganization(org.id).then(function (response) {
                org.settings = response;
                return org;
              }, function (response) {
                Logger.error("OrganizationContext.load failed to load, " + "got response status " + response.status);
                return $q.reject("Fetching organization settings for org " + org.id + " failed with status " + response.status);
              }).then(
              // Now set the cookie and resolve the promise
              function (org) {
                $cookies.put(self.cookieName, JSON.stringify(org));
                self.value = org;
                self.deferredOrg.resolve(org);
              }, function (err) {
                self.deferredOrg.reject(err);
              });
            }
          }, function (response) {
            Logger.debug("OrganizationContext.load failed to load " + orgUrl + ", " + "got response status " + response.status);
            $cookies.remove(self.cookieName);
            self.value = null;
            return self.deferredOrg.resolve(null);
          });
        }
        return self.deferredOrg.promise;
      },
      get: function get() {
        if (this.value === null) {
          var strVal = $cookies.get(this.cookieName);
          if (typeof strVal === "undefined" || strVal === null) {
            return null;
          }
          try {
            this.value = JSON.parse(strVal);
          } catch (e) {
            Logger.warn("Unexpected org representation: '" + strVal + "'");
            this.value = null;
          }
        }
        return this.value;
      },
      clear: function clear() {
        $cookies.remove(this.cookieName);
        this.value = null;
        this.deferredOrg = null;
      }
    };
  }]);
})();
